'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';

var getUrlParameter = function (url, name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(url);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
var callTrackingUTM = function (event, apiLink) {
    var getFiltersFromNaviCMS = function (form) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(apiLink, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(form)
                    })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var form = {
        utm_source: '',
        utm_campaign: '',
        utm_medium: '',
        utm_content: '',
        utm_term: ''
    };
    var element = event.currentTarget;
    form.utm_source = getUrlParameter(element.href, 'utm_source');
    form.utm_campaign = getUrlParameter(element.href, 'utm_campaign');
    form.utm_medium = getUrlParameter(element.href, 'utm_medium');
    form.utm_content = getUrlParameter(element.href, 'utm_content');
    form.utm_term = getUrlParameter(element.href, 'utm_term');
    if (!form.utm_source)
        form.utm_source = getUrlParameter(element.href, 'utm_source_navi');
    if (!form.utm_campaign)
        form.utm_campaign = getUrlParameter(element.href, 'utm_campaign_navi');
    if (!form.utm_medium)
        form.utm_medium = getUrlParameter(element.href, 'utm_medium_navi');
    if (!form.utm_content)
        form.utm_content = getUrlParameter(element.href, 'utm_content_navi');
    if (!form.utm_term)
        form.utm_term = getUrlParameter(element.href, 'utm_term_navi');
    getFiltersFromNaviCMS(form);
};
var formatCanonicalUrl = function (url) {
    var urlFormat = url.split('?')[0];
    // remove '/' if it's final word, www.vietnamworks.com/hcm-kw/ -> www.vietnamworks.com/hcm-kw
    return urlFormat.replace(/\/$/, '');
};

export { callTrackingUTM, formatCanonicalUrl, getUrlParameter };
//# sourceMappingURL=utmTracking.js.map
